// extracted by mini-css-extract-plugin
export default {"link":"link__cOXLy","row":"row__RadyV","column":"column__Yi9rt","body":"body__9-5Md","core":"core__cA5fN","img":"img__Av8ds"};